import get from 'lodash.get';

import { RESET_STATE } from 'services/auth/constants';

import { ACTIVE_INGREDIENTS_SET, ACTIVE_INGREDIENT_SET } from './constants';
import { ActiveIngredientsState, ActiveIngredientsActions } from './types';

const initialState: ActiveIngredientsState = {};

export default function (
    state: ActiveIngredientsState = initialState,
    action: ActiveIngredientsActions
): ActiveIngredientsState {
    switch (action.type) {
        case ACTIVE_INGREDIENTS_SET:
            return get(action, 'payload', {});
        case ACTIVE_INGREDIENT_SET:
            return {
                ...state,
                ...get(action, 'payload', {})
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
